import React from 'react';
import PropTypes from 'prop-types';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import { useFacetPlanContext } from 'Components/FacetPlan/FacetPlanContext';

const styles = () => ({
  root: {},
});

const FacetPlanDataContainer = ({
  component,
}) => {
  const { facetPlan } = useFacetPlanContext();

  return (
    <FullScreenDataContainer
      component={component}
      loading={!facetPlan}
    />
  );
};

FacetPlanDataContainer.defaultProps = {
};

FacetPlanDataContainer.propTypes = {
  component: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanDataContainer);
